import React from 'react';
import NoteBell from '../../../../../assets/note-bell.png';
import Button from 'components/Form/Button';
import { Link } from 'react-router-dom';
import { InfoModal } from 'components/Modal';

export default function CreateInstructionModal() {
  return (
    <InfoModal width="w-[60%]" className="h-fit rounded-md p-7">
      <div className="flex flex-col items-center justify-center px-[10rem] pb-10 text-center">
        <img src={NoteBell} />
        <p className="mt-1 text-2xl font-bold leading-8 text-[#34475E]">
          If you have other instructions you wish to include in your will which
          have not been previously captured, please let us know.
        </p>
        <Link to="special-instructions">
          <Button
            variant="primary"
            size="md"
            className="mt-10 w-[13rem] rounded p-[0.2rem]"
            label="Create Instructions"
            type="button"
          ></Button>
        </Link>
      </div>
    </InfoModal>
  );
}
